var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-container"},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-sizes":_vm.pageSizes,"page-size":_vm.size,"layout":_vm.layout,"total":_vm.total,"background":"","small":""},on:{"size-change":_vm.sizeChange,"current-change":_vm.pageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }